import { AbortError, ensureAuthenticatedUser } from '@forest/paywall-core'
import { m } from '~/paraglide/messages'
import { getReceiptSystemAccountIdSafe, native } from '@forest/native-services'
import type { UserInfo } from '@forest/native-services'
import { appVersion } from '~/params'
import { closeButton } from '~/store/close-button'
import { dialog } from '~/store/dialog'
import { $receiptSystemAccountId } from '~/store/receipt-system-account-id'
import { $userInfo } from '~/store/user-info'

export { AbortError }

export async function getAuthenticatedUserInfo(): Promise<UserInfo> {
  const userInfo = await ensureAuthenticatedUser({
    getUserInfo: async () => {
      const current = $userInfo.get()
      if (!current) throw new Error('userInfo is null')
      return { success: true, data: current }
    },
    auth: () => native.auth.auth(),
    bindLegacyUser: () => native.auth.bindLegacyUser(),
    onBeforeGuestUpgrade: () =>
      new Promise<void>((resolve, reject) => {
        dialog.open({
          title: m.dialog_log_in_title(),
          description: m.dialog_log_in_content(),
          button: m.OK(),
          action: resolve,
          closeButton: {
            action: () => reject(new AbortError()),
          },
        })
      }),
    onAfterGuestUpgrade: async () => {
      $receiptSystemAccountId.set(
        await getReceiptSystemAccountIdSafe(appVersion),
      )
    },
    onBeforeLegacyBind: () =>
      new Promise<void>((resolve, reject) => {
        dialog.open({
          title: m.dialog_log_in_legacy_title(),
          description: m.dialog_log_in_legacy_content(),
          button: m.OK(),
          action: resolve,
          closeButton: {
            action: () => reject(new AbortError()),
          },
        })
      }),
    onLegacyBindStart: () => closeButton.hide(),
    onLegacyBindEnd: () => closeButton.show(),
    onUserInfo: (nextUserInfo) => {
      $userInfo.set(nextUserInfo)
    },
  })

  return userInfo
}
